/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding, AfterViewInit } from '@angular/core';

import { isPresent } from '../util/lang';
import classNames from 'classnames';
/**
 * 徽标数
 */
export class Badge implements AfterViewInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-badge';
/**
 * 展示的数字，大于 overflowCount 时显示为 `${overflowCount}+`，为 0 时隐藏。 Number to show in badge
 */
count: number;
/**
 * 当数值为 0 时，是否展示 Badge
 */
showZero = false;
/**
 * 展示封顶的数字值。Max count to show
 */
overflowCount = 99;
/**
 * 不展示数字，只有一个小红点。 whether to show red dot without number
 */
dot = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 设置 Badge 为状态点
 */
status: 'success' | 'processing' | 'default' | 'error' | 'warning';
/**
 * 在设置了 `status` 的前提下有效，设置状态点的文本
 */
text: string;
/**
 * 内部徽标样式
 */
badgeStyle: any;
/**
 * 颜色，取值：default、primary、warn等。默认为default。<br>
 * 自定义的颜色名称与色值，可以定义在 工程根目录/src/theme/variables.scss 文件中的 $colors 对象。
 */
color = 'default';
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        const /** @type {?} */ el = /** @type {?} */(( this._elementRef.nativeElement as HTMLElement));
        if (el) {
            const /** @type {?} */ childCount = el.childElementCount - el.querySelectorAll('scroll-number').length;
            this._renderer.setElementClass(el, `${this.prefixCls}-not-a-wrapper`, childCount <= 0);
        }
    }
/**
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classString = classNames(this.prefixCls, {
            [`${this.prefixCls}-status`]: !!status
        }, this.class);
        return classString;
    }
/**
 * @return {?}
 */
get title(): string {
        return isPresent(this.count) ? `${this.count}` : null;
    }
/**
 * @return {?}
 */
getStatusCls(): any {
        const /** @type {?} */ status = this.status;
        return {
            [`${this.prefixCls}-status-dot`]: !!status,
            [`${this.prefixCls}-status-${status}`]: true,
        };
    }
/**
 * @return {?}
 */
getScrollNumberCls(): string {
        const /** @type {?} */ isDot = this.dot || !!status;
        return classNames({
            [`${this.prefixCls}-dot`]: isDot,
            [`${this.prefixCls}-count`]: !isDot
        });
    }
/**
 * @return {?}
 */
isOverflowCount(): boolean {
        return this.count > this.overflowCount;
    }
/**
 * @return {?}
 */
getCountText(): string {
        const /** @type {?} */ isDot = this.dot;
        return !isDot && this.isOverflowCount() ? `${this.overflowCount}+` : null;
    }
/**
 * @return {?}
 */
isCountTextVisible(): boolean {
        const /** @type {?} */ isDot = this.dot;
        if (isDot) {
            return true;
        }
        if (isPresent(this.count)) {
            return (this.count > 0) || (this.count === 0 && this.showZero);
        }
        return false;
    }



static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-badge',
    templateUrl: './badge.html',
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'count': [{ type: Input },],
'showZero': [{ type: Input },],
'overflowCount': [{ type: Input },],
'dot': [{ type: Input },],
'class': [{ type: Input },],
'status': [{ type: Input },],
'text': [{ type: Input },],
'badgeStyle': [{ type: Input },],
'color': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'title': [{ type: HostBinding, args: ['attr.title', ] },],
};
}

function Badge_tsickle_Closure_declarations() {
/** @type {?} */
Badge.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Badge.ctorParameters;
/** @type {?} */
Badge.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Badge.prototype.prefixCls;
/**
 * 展示的数字，大于 overflowCount 时显示为 `${overflowCount}+`，为 0 时隐藏。 Number to show in badge
 * @type {?}
 */
Badge.prototype.count;
/**
 * 当数值为 0 时，是否展示 Badge
 * @type {?}
 */
Badge.prototype.showZero;
/**
 * 展示封顶的数字值。Max count to show
 * @type {?}
 */
Badge.prototype.overflowCount;
/**
 * 不展示数字，只有一个小红点。 whether to show red dot without number
 * @type {?}
 */
Badge.prototype.dot;
/**
 * 用户CSS样式
 * @type {?}
 */
Badge.prototype.class;
/**
 * 设置 Badge 为状态点
 * @type {?}
 */
Badge.prototype.status;
/**
 * 在设置了 `status` 的前提下有效，设置状态点的文本
 * @type {?}
 */
Badge.prototype.text;
/**
 * 内部徽标样式
 * @type {?}
 */
Badge.prototype.badgeStyle;
/**
 * 颜色，取值：default、primary、warn等。默认为default。<br>
 * 自定义的颜色名称与色值，可以定义在 工程根目录/src/theme/variables.scss 文件中的 $colors 对象。
 * @type {?}
 */
Badge.prototype.color;
/** @type {?} */
Badge.prototype._renderer;
/** @type {?} */
Badge.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
